import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BookingProcess from '../../components/BookingProcess/index';
import BookingPending from '../../components/ProcessPending/index';
import Error from '../../components/Error/index';

function BookingComponent() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();

  const tryAgain = () => {
    navigate('/');
  };

  return (
    <>
      {!error ? (
        <>
          {loading && <BookingPending processName="booking" />}
          <BookingProcess
            loading={loading}
            setLoading={setLoading}
            setError={setError}
            paymentWindowRef={state?.paymentWindowRef}
          />
        </>
      ) : (
        <Error processName="booking" actionCallback={tryAgain} />
      )}
    </>
  );
}

export default BookingComponent;